module.exports = {"150926105":"土贵乌拉镇","150926106":"平地泉镇","150926107":"玫瑰营镇","150926108":"巴音塔拉镇","150926109":"黄旗海镇","150926209":"乌拉哈乌拉乡","150926210":"黄茂营乡","150926211":"三岔口乡","150926212":"老圈沟乡","150926400":"察右前旗天皮山冶金化工工业园区","150926401":"察右前旗察哈尔工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150926.json
// module id = 426
// module chunks = 0